import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	createCustomDuration: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.template-select.timing-menu-list.create-custom-duration',
		defaultMessage: 'Create custom duration',
		description: 'Label for extra dropdown item for switching to adding your own timings.',
	},
});

export { messages };
